import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IMegaMenuSettings } from '@ncg/data';
import { UtilsModule } from '../../../utils/utils.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ncg-alt-menu-highlight',
    template: `
        <div class="mega-menu__item mega-menu__item--animate">
            <ng-container *ngIf="data.highlightLink?.url; else highLightContent">
                <ng-container *ngIf="data.highlightLink?.isExternal; else internalLink">
                    <a
                        role="menuitem"
                        class="animate-mask__link"
                        [href]="data.highlightLink?.url"
                        [attr.target]="data.highlightLink?.target"
                        [attr.title]="data.highlightLinkHoverTitle"
                        [attr.aria-label]="data.highlightLinkHoverTitle"
                        rel="noopener">
                        <ng-container *ngTemplateOutlet="highLightContent"></ng-container>
                    </a>
                </ng-container>
                <ng-template #internalLink>
                    <a
                        role="menuitem"
                        class="animate-mask__link"
                        [routerLink]="data.highlightLink?.url"
                        [attr.target]="data.highlightLink?.target"
                        [attr.title]="data.highlightLinkHoverTitle"
                        [attr.aria-label]="data.highlightLinkHoverTitle">
                        <ng-container *ngTemplateOutlet="highLightContent"></ng-container>
                    </a>
                </ng-template>
            </ng-container>
            <ng-template #highLightContent>
                <div class="mega-menu-image image-wrapper animate-mask is-small-mask">
                    <img
                        *ngIf="data.highlightImage"
                        [src]="data.highlightImage | imageUrl: { width: 256, height: 144, mode: 'crop' }"
                        [srcset]="data.highlightImage | imageUrl: { width: 256, height: 144, mode: 'crop' } : 2"
                        [alt]="data.highlightImage.altText"
                        loading="lazy"
                        ncgImageLoad />
                </div>
                <h3 class="highlight-heading" *ngIf="data.highlightHeading">
                    {{ data.highlightHeading }}
                </h3>
                <p class="highlight-text" *ngIf="data.highlightText">
                    {{ data.highlightText }}
                </p>
                <button class="button is-primary is-small" type="button" *ngIf="data.showHighlightCTA">
                    {{ data.highlightLink?.name }}
                </button>
            </ng-template>
        </div>
    `,
    styleUrls: ['./alt-menu-highlight.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, UtilsModule, NgIf, NgTemplateOutlet, TranslateModule],
})
export class AltMenuHighlightComponent {
    @Input()
    public data: IMegaMenuSettings = {};
}
